import './AutoCalculationSection.css';
import React from 'react';
import { Insights, StatusCalculationTypes } from "../../../store/Tenant";
import { IInsightsData } from "../../../entities/common";
import { nameof } from "../../../store/services/metadataService";
import { contains } from "../../../store/permissions";
import { ConfirmationDialog } from '../../common/ConfirmationDialog';
import { ProjectInfo } from '../../../store/ProjectsListStore';
import { SectionToggle } from './SectionToggle';

export const AutoCalculationSection = (props: {
    readonly?: boolean,
    tenantInsights: Insights
    projectInsights: IInsightsData,
    onChangeInsights: (insights: Partial<IInsightsData>) => void,
    project: ProjectInfo,
    calculateStartFinishDate: boolean,
    onChangeCalculateStartFinishDate: (calculateStartFinishDate: boolean) => void,
}) => {
    const [showDatesConfirmation, setShowDatesConfirmation] = React.useState(false);

    const toggles =
        [
            {
                id: nameof<IInsightsData>("statusCalculationDisabled"),
                label: "Project Statuses",
                disabled: props.readonly || !contains(props.tenantInsights.project.statusCalculation, StatusCalculationTypes.Auto),
            },
            {
                id: nameof<IInsightsData>("keyDateStatusCalculationDisabled"),
                label: "Key Dates Statuses",
                disabled: props.readonly || !contains(props.tenantInsights.keyDate.statusCalculation, StatusCalculationTypes.Auto),
            },
            {
                id: nameof<IInsightsData>("taskStatusCalculationDisabled"),
                label: "Tasks Statuses",
                disabled: props.readonly || !contains(props.tenantInsights.task.statusCalculation, StatusCalculationTypes.Auto),
            },
            {
                id: nameof<IInsightsData>("warningsCalculationDisabled"),
                label: "Warnings",
                disabled: props.readonly || props.tenantInsights.projectWarningsCalculationDisabled,
            },
        ];

    const onChangeCalculateStartFinishDate = React.useCallback((checked: boolean) => {
        if (checked && props.project.settings.calculateStartFinishDate !== checked
            && (props.project.attributes.StartDate || props.project.attributes.FinishDate)) {
            setShowDatesConfirmation(checked);
            return;
        }
        props.onChangeCalculateStartFinishDate(checked);
    }, [props.project, showDatesConfirmation]);

    return <div className="calculation-automatically">
        <div className='section-description'>
            Select which statuses to auto-calculate, whether to display warnings, and if the project's start and finish dates should roll up from the primary schedule.
        </div>
        <ul className="scrollable-content cb-list">
            {toggles.map(item => <SectionToggle
                key={item.id}
                label={item.label}
                disabled={item.disabled}
                checked={!props.projectInsights[item.id]}
                onChange={c => props.onChangeInsights({ [item.id]: !c })}
            />)}
            <SectionToggle
                key="calculateStartFinishDate"
                label="Project Start and Finish"
                description="When turned on, project’s Start Date and Finish Date are automatically rolled up from the primary schedule. When turned off, project’s Start Date and Finish Date are set manually."
                disabled={props.readonly}
                checked={props.calculateStartFinishDate}
                onChange={onChangeCalculateStartFinishDate}
            />
            {showDatesConfirmation && <ConfirmationDialog
                yesButtonProps={{ text: "Confirm" }}
                noButtonProps={{ text: "Cancel" }}
                dialogContentProps={{
                    title: 'Auto Calculate Project Start and Finish',
                    subText: `Project’s Start Date and/or Finish Date already have values.
These values will be overwritten with the rolled-up dates from the primary schedule if the primary schedule has at least one task with Start & Due Date.`
                }}
                onDismiss={() => setShowDatesConfirmation(false)}
                onYes={() => props.onChangeCalculateStartFinishDate(true)}
                onNo={() => { }}
            />}
        </ul>
    </div>;
}


